import initLazyLoad from './lazyLoad';

const globalListeners = () => {
  initLazyLoad();
};

export default globalListeners;
